import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpRequestResponse } from '../../lib/models/http-request-response.model';
import { HttpRequestService } from '../../lib/services/http-request.service';
import { LogService } from '../../lib/services/log.service';
import { newError } from '../../lib/utils/Utility';

export interface AvvisoComunicazioni {
  fonte: 'AVVISO' | 'NOTIFICA';
  codguid?: string;
  id_notifica?: number;
  tipo_avviso: string;
  titolo: string;
  testo: string;
  data_inserimento: string;
  data_ordinamento: string;
  letto: boolean;
}

export interface RispostaAvvisiComunicazioni {
  avvisi: AvvisoComunicazioni[];
  nonLetti: number;
}

@Injectable({ providedIn: 'root' })
export class AvvisiComunicazioniService {
  private http = inject(HttpRequestService);
  private log = inject(LogService);
  private avvisiNonLettiSubject = new BehaviorSubject<number>(0);
  readonly avvisiNonLetti$ = this.avvisiNonLettiSubject.asObservable();

  carica(limit = 50, soloNonLetti = false) {
    return this.http.post('/avvisi-comunicazioni/', { limit, soloNonLetti }, {}, false).pipe(
      map(response => {
        if (HttpRequestResponse.isSuccessResponse(response)) {
          const result = response.data as RispostaAvvisiComunicazioni;
          this.impostaNumeroAvvisiNonLetti(result?.nonLetti || 0);
          return result;
        }

        this.log.messageError('Attenzione', response.message, newError(response.message));
        return null;
      })
    );
  }

  aggiornaNumeroAvvisiNonLetti() {
    return this.carica(1).pipe(
      map(result => result?.nonLetti || 0)
    );
  }

  segnaComeLetti(codguids: string[], idsNotifiche: number[]) {
    return this.http.post('/avvisi-comunicazioni/letti', {
      codguids: JSON.stringify(codguids),
      idsNotifiche: JSON.stringify(idsNotifiche)
    }, {}, false).pipe(
      map(response => {
        if (HttpRequestResponse.isSuccessResponse(response)) {
          const nonLetti = Number(response.data?.nonLetti || 0);
          this.impostaNumeroAvvisiNonLetti(nonLetti);
          return nonLetti;
        }

        this.log.messageError('Attenzione', response.message, newError(response.message));
        return null;
      })
    );
  }

  private impostaNumeroAvvisiNonLetti(value: number) {
    this.avvisiNonLettiSubject.next(Math.max(0, Number(value) || 0));
  }
}
